//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { restEditListFn } from 'api/approval/config';
export default {
  data: function data() {
    return {
      visible: false,
      item: {},
      dataForm: {},
      steps: 0.5,
      options: [{
        label: this.$t('146'),
        value: 1
      }, {
        label: this.$t('147'),
        value: 2
      }],
      disabled: false
    };
  },
  methods: {
    init: function init(item, row) {
      this.steps = item.leave_quota_type === 1 ? 0.5 : 1;
      this.visible = true;
      this.item = item;
      this.dataForm = {
        staff_id: row.staff_id,
        leave_type: item.type_id,
        day_count: 1,
        type: 1
      };
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;
      this.disabled = true;
      restEditListFn(this.dataForm).then(function (res) {
        _this.disabled = false;
        if (res && res.code === 1) {
          _this.visible = false;
          _this.$message.success('success');
          _this.$emit('getTableList');
        }
      }).catch(function () {
        _this.disabled = false;
      });
    }
  }
};